import React from "react";
import { createImageFromInitials } from "../../AgentLogo";
import Avatar from "../../static/images/Chat_icon.png";
import callIcon from "../../static/images/videoCallIcon.png";
import presentationImage from "../../static/images/vcPresentation.png";

export default function TermChatHeader({showVideoCallButton, empId, agentName, showModal, messageCounter, botName, miniMize , roomClosed}) {
  const onVCButtonClick = () => {
    if (window && window.parent) {
      window.parent.postMessage({ message: 'Video Call Button Clicked', action: "VideCallButtonClicked", videoCallButtonClicked: true ,agentId:empId }, '*');
    }
  }
  
  return (
    <>
    <header {...(showVideoCallButton ? { style: { marginBottom: 0 } } : {})}>
      <div class="heading-with-icon">
        <div class="chaticon">
          {/* <div className="onlineDot"></div> */}
          {/* {agentName ?
            <img
              id='preview'
              src={
                createImageFromInitials(500, agentName, "blue")   //getRandomColor()
              }
              alt='profile-pic'
            />
            : */}
            <img src={Avatar} alt=""></img>
          {/* } */}
        </div>
        <div className="bot-name">
          <h3>{agentName ? agentName : "Ask Policybazaar" || "Policybazaar"}</h3>
          {/* <p>Term Insurance Expert</p> */}
          <p className="online-status"><span className="online-status-dot"></span>Online</p>
          {/* <div className="carRating"></div> */}
        </div>
        {/* {showVideoCallButton ?
          <button className="videoCallButton" onClick={() => onVCButtonClick()} >
            <img src={callIcon} ></img>
            Get a Call</button> : null} */}
        <div className="endchat">
          {/* <div onClick={() => showModal()} className="closeIcon">&#x2715;</div> */}
          <div onClick={() => miniMize()} className="minimizeIcon">&minus;</div>
        </div>
      </div>

    </header>
      {showVideoCallButton && !roomClosed ?
        <div class="presentation-card">
          <img src={presentationImage} alt="Presentation" class="presentation-image" />

          <div class="presentation-text">
            <p>{agentName}’s quick presentation can help you choose the right term plan.</p>
          </div>

          <button class="join-now-btn" onClick={() => onVCButtonClick()}>Join now</button>
        </div>

        : null}

    </>
  );
}